//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/AttributePropertiesBaseBuilder.js";
import "../no/DateItemBuilder.js";
import "../no/Assemblies.js";
import "../no/FileNew.js";
import "../no/PDMDebugSession.js";
import "../no/PDM.js";
import "../no/Session.js";
import "../no/DebugSession.js";
let d=[[],[[[],"InitializeCustomDECreationInputFlags",{R_:{customDEreationInputFlags:''}},0,0],[[],"InitializeShapeDECreationInput",{R_:{shapeDECreationInput:''}},0,0],[[],"InitializePromissoryDECreationInput",{R_:{promissoryDECreationInput:''}},0,0],[[],"InitializeReuseDECreationInput",{R_:{reuseDECreationInput:''}},0,0],[[],"InitializeSubsetCreationInput",{R_:{subsetCreationInput:''}},0,0],[[],"InitializeCustomShapeItemCreationInputFlags",{R_:{customShapeItemCreationInputFlags:''}},0,0],[[],"InitializeCustomWorksetCreationInputFlags",{R_:{customWorksetCreationInputFlags:''}},0,0],[[],"InitializeCustomItemCreationInputFlags",{R_:{customItemCreationInputFlags:''}},0,0],[["nx_flags"],"SetNxPartInfoFlags",{},1,0],[[],"GetDefaultNxPartInfoFlags",{R_:{flags:''}},0,0],[[],"GetCurrentNxPartInfoFlags",{R_:{flags:''}},0,0],[[],"GetDefaultWorksetInfoFlags",{R_:{flags:''}},0,0],[["partSpec"],"GetTempExportDir",{R_:{tempExportDir:''}},1,0],[["testcaseName"],"InitializeTest",{},1,0],[[],"AskConfigRule",{R_:{configRule:''}},0,0],[["configRule"],"SetConfigRule",{},1,0],[["partName","itemType","itemRevType"],"CreateNewPart",{},3,0],[["partName","usingPartOperationBuilder"],"CreateNewPart1",{},2,0],[["itemType","masterPart","datasetName","autoAssign"],"CreateDrawingOfPart",{},4,0],[["partName","revision","itemType","autoAssignDsName","usingPartOperationBuilder"],"CreateDrawingOfPart1",{},5,0],[["partType","masterPart","datasetName"],"CreateDrawingOfPartWithBlankTemplate",{},3,0],[["partType","partName","revision","usingPartoperationBuilder"],"CreateDrawingOfPartWithBlankTemplate1",{},4,0],[["itemType","masterPart","datasetName","autoAssign"],"CreateAltrepOfPart",{},4,0],[[],"AddBlock",{},0,0],[["originX","originY","originZ","length","width","height"],"AddBlock1",{},6,0],[["blockFeatureName","originX","originY","originZ","length","width","height"],"EditParametersOfBlock",{},7,0],[["componentToLoad","partialLoad","interPart","allowSubstitute"],"SetLoadOption",{},4,0],[["workSetType","worksetId","worksetRev","tempFileName","defaultFolderLoc"],"CreateNewWorkset",{},5,0],[["workSetType","worksetId","worksetRev","tempFileName"],"CreateNewWorkset1",{},4,0],[["collabDesignID","worksetName","subsetName","subsetDescription","subsetRevisionRule","subsetSetEffectivity"],"CreateNewSubset",{},6,0],[["subsetName"],"SetSubsetAsWorkPart",{},1,0],[["subsetName","designElementId","designElementName","designElementDescription"],"CreateNewShapeDesignElement",{},4,0],[["shapeDECreationInput"],"CreateNewShapeDesignElement1",{},1,0],[["testcaseName"],"FinalizeTest",{},1,0],[[],"PrintLoadOptions",{},0,0],[["encodedName"],"OpenPart",{},1,0],[["encodedName"],"SetDisplayPart",{},1,0],[["encodedName"],"SetWorkPart",{},1,0],[[],"SaveWorkPart",{},0,0],[[],"ForceSaveAll",{},0,0],[["itemType","itemId","revId","fileType","fileName"],"SaveWorkPartAs",{},5,0],[["newItemId","newRevId","newItemName","operationType"],"SaveWorkPartAs1",{},4,0],[["itemType","itemId","revId","fileType","fileName","saveAsOption"],"SaveWorkPartAsWithOption",{},6,0],[[],"CloseAllParts",{},0,0],[["encodedName","closeAllChildren"],"ClosePart",{},2,0],[["encodedName","printTableEntry","levels"],"PrintNxpartInformation",{},3,0],[["encodedName","levels","relations"],"PrintTcpartInformation",{},3,0],[["encodedName"],"PrintNxpartMaterialSpecificationInformation",{},1,0],[["encodedName"],"PrintTcpartMaterialSpecificationInformation",{},1,0],[[],"PrintDisplayPartInformation",{},0,0],[["operation"],"InitializeClone",{},1,0],[["namingTech"],"SetCloneNamingTechnique",{},1,0],[["namingRule","base","str"],"SetCloneNaming",{},3,0],[["folderName"],"SetCloneFolder",{},1,0],[["directory"],"SetCloneDirectory",{},1,0],[["owner"],"SetCloneOwner",{},1,0],[["relations"],"SetCloneCheckin",{},1,0],[["relations","comment"],"SetCloneCheckout",{},2,0],[[],"FinishClone",{},0,0],[["asmName","revUp"],"ImportAssemblyWithOptions",{},2,0],[["asmName"],"CloneAssemblyWithOptions",{},1,0],[["asmName"],"ExportAssemblyWithOptions",{},1,0],[["asmName","revUp"],"ImportAssembly",{},2,0],[["asmName","revUp","namingRule","base","str"],"ImportAssembly1",{},5,0],[["asmName","namingRule","base","str"],"ExportAssembly",{},4,0],[["asmName"],"ExportAssembly1",{},1,0],[["imageName","cmdLineArgs"],"SpawnImage",{},2,0],[["imageName","cmdLineArgs"],"SpawnImageInBatchMode",{},2,0],[["imageName"],"FindRunAutotestDll",{R_:{absolutePathImageName:''}},1,0],[["inputFile","logFile"],"NxManagerRefile",{},2,0],[["synchroniseOnLoadType"],"SetStructureUpdateOnLoad",{},1,0],[[],"SetMCDRefSets",{},0,0],[["encodedName","numLevels"],"UpdateStructure",{},2,0],[["numLevels"],"UpdateRootStructure",{},1,0],[["updateStructureOnExpand"],"SetExpandPreference",{},1,0],[["messagesInconsistentRevisionsType"],"SetMessagesInconsistentRevisions",{},1,0],[["jtUpdateFromSource"],"SetJtUpdateFromSource",{},1,0],[["partToAdd","refSetName"],"AddPartToWorkPart",{},2,0],[["validatePart"],"ValidateAllBodiesInPart",{},1,0],[["compName","status"],"SetComponentReferenceOnlyStatus",{},2,0],[[],"OpenVisualReporting",{},0,0],[["vrReportDefinitionFile"],"SetCurrentVisualReport",{},1,0],[[],"ActivateCurrentVisualReport",{},0,0],[["vrpName","vrpDescription","vrpKeywords","vrpPropertyType","vrpProperty","vrpUnmatchedGroupEnabled","vrpLocation"],"CreateVisualReport",{},7,0],[["app","partType","partName","revision","tempFileName"],"CreateNewMasterPart",{},5,0],[["validatePart"],"GetPromotedGeometryFeatureCount",{},1,0],[["effectivityValue","endItem","dateEffValue","revisionRule"],"ApplyEffectivityAndRevisionRule",{},4,0],[["inputFileName"],"DumpTranslationInfo",{},1,0],[[],"PrintRefDesignator",{},0,0],[[],"PrintIsSuppressed",{},0,0],[[],"PrintComponents",{},0,0],[["testName","userName","userPswd"],"RunAnotherNXSessionAndRunJournal",{},3,0],[["testName","userName","userPswd"],"RunAnotherNXSessionAndRunJournalInternally",{},3,0],[[],"PrintPartLoadInfo",{},0,1],[["workset","flags"],"PrintNXWorksetInformation",{},2,0],[["designElementName","flags"],"PrintNXDesignElementInformation",{},2,0],[["itemId","expand","propertiesToDump"],"PrintTcNavPartItemInformation",{},3,0],[["itemRevId","expand","propertiesToDump"],"PrintTcNavPartItemRevInformation",{},3,0],[["cdId","propertiesToDump"],"PrintTcNavCollaborativeDesignInformation",{},2,0],[["itemId","expand","propertiesToDump"],"PrintTcNavWorksetItemInformation",{},3,0],[["folderPath","detailLevel","revOption","propertiesToDump"],"PrintTcNavFolderContentsInformation",{},4,0],[["folderPath","propertiesToDump"],"PrintTcNavFolderInformation",{},2,0],[["itemRevId","expand","propertiesToDump"],"PrintTcNavWorksetItemRevInformation",{},3,0],[["dceName","flags"],"PrintNXDesignControlElementInformation",{},2,0],[["dfName","flags"],"PrintNXDesignFeatureInformation",{},2,0],[["collaborativeDesignId"],"PrintTCCollaborativeDesignInformation",{},1,0],[["partitionId"],"PrintTCPartitionInformation",{},1,0],[["designControlElementName","flags"],"PrintTCDesignControlElementInformation",{},2,0],[["designFeatureName","flags"],"PrintTCDesignFeatureInformation",{},2,0],[["worksetName","flags"],"PrintTCWorksetInformation",{},2,0],[["worksetNames"],"CompareWorksetInformationBetweenNXandTC",{},1,0],[["collaborativeDesignID","collaborativeDesignName","collaborativeDesignFolder"],"CreateCollaborativeDesign",{},3,0],[["subsetName","DE_SID"],"SetDEAsWorkPart",{},2,0],[["part","subsetName","DE_SID"],"SetDEAsWorkPart1",{},3,0],[["ecnName"],"PrintTcEcnInformation",{},1,0],[[],"PrintSheetsAndDescendentsInformation",{},0,0],[[],"PrintNXSheetsAndDescendentsInformation",{},0,0],[[],"PrintFileNameMappingsInformation",{},0,0],[[],"PrintDeltasInformation",{},0,0],[[],"PrintPendingComponents",{},0,0],[["parentComponentName","componentName","arrangementName","x","y","z"],"TranslateComponent",{},6,0],[["soaXmlStream"],"DumpSoaXml",{},1,0],[["dateToFormat"],"FormatDateTimeToLocale",{R_:{formattedDate:''}},1,0],[["formattedDate","time_string","day","month","year"],"GetTimeString",{},1,0],[[],"DisconnectTcForRescue",{},0,0],[[],"CheckTcConnectForRescue",{R_:{isSessionValidForCrashRecovery:''}},0,0],[["inputFile","filterFlags"],"TcPublishWrapper",{},2,0],[["changeNotice","worksetPart"],"CreateChangeNoticeSubset",{},2,0],[["nx_flags"],"SetPartinfoflagsForConfigcontextValidation",{},1,0],[[],"InitPerformCopyOptions",{R_:{copyOptions:''}},0,0],[["partsToClone"],"PerformCopyInDatabase",{},1,0],[["partsToClone","copyOptions"],"PerformCopyInDatabaseWithOptions",{},2,0]],[]];
SPLM.TCINDebugSession = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.TCINDebugSession";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.TCINDebugSession.AttributeInput = class{
    constructor(attributeTitle,attributeCategory,attributeType,isNewAttribute,isArray,boolValues,intValues,numberValues,stringValues,dateValues){
        this.attributeTitle=attributeTitle;this.attributeCategory=attributeCategory;this.attributeType=attributeType;this.isNewAttribute=isNewAttribute;this.isArray=isArray;this.boolValues=boolValues;this.intValues=intValues;this.numberValues=numberValues;this.stringValues=stringValues;this.dateValues=dateValues;}
    get Attributetitle(){return this.attributeTitle}
    set Attributetitle(val){this.attributeTitle = val}
    get Attributecategory(){return this.attributeCategory}
    set Attributecategory(val){this.attributeCategory = val}
    get Attributetype(){return this.attributeType}
    set Attributetype(val){this.attributeType = val}
    get Isnewattribute(){return this.isNewAttribute}
    set Isnewattribute(val){this.isNewAttribute = val}
    get Isarray(){return this.isArray}
    set Isarray(val){this.isArray = val}
    get Boolvalues(){return this.boolValues}
    set Boolvalues(val){this.boolValues = val}
    get Intvalues(){return this.intValues}
    set Intvalues(val){this.intValues = val}
    get Numbervalues(){return this.numberValues}
    set Numbervalues(val){this.numberValues = val}
    get Stringvalues(){return this.stringValues}
    set Stringvalues(val){this.stringValues = val}
    get Datevalues(){return this.dateValues}
    set Datevalues(val){this.dateValues = val}
};

SPLM.TCINDebugSession.TestUtilsCustomDECreationInputFlags = class{
    constructor(tc9CrLocal,tc9CrString,tc9CrChar,tc9CrBool,tc9CrDouble,tc9CrLongStr,tc9CrLOVc,tc9CrLOVe,mdl0logical_designator,tc9CrLOVsInt,tc9CrLOVr,tc9CrInt,tc9CrLOVs,tc9CrLOVsDate,tc9CrDate,tc9PRequired,tc9CrCharVLA){
        this.tc9CrLocal=tc9CrLocal;this.tc9CrString=tc9CrString;this.tc9CrChar=tc9CrChar;this.tc9CrBool=tc9CrBool;this.tc9CrDouble=tc9CrDouble;this.tc9CrLongStr=tc9CrLongStr;this.tc9CrLOVc=tc9CrLOVc;this.tc9CrLOVe=tc9CrLOVe;this.mdl0logical_designator=mdl0logical_designator;this.tc9CrLOVsInt=tc9CrLOVsInt;this.tc9CrLOVr=tc9CrLOVr;this.tc9CrInt=tc9CrInt;this.tc9CrLOVs=tc9CrLOVs;this.tc9CrLOVsDate=tc9CrLOVsDate;this.tc9CrDate=tc9CrDate;this.tc9PRequired=tc9PRequired;this.tc9CrCharVLA=tc9CrCharVLA;}
    get Tc9crlocal(){return this.tc9CrLocal}
    set Tc9crlocal(val){this.tc9CrLocal = val}
    get Tc9crstring(){return this.tc9CrString}
    set Tc9crstring(val){this.tc9CrString = val}
    get Tc9crchar(){return this.tc9CrChar}
    set Tc9crchar(val){this.tc9CrChar = val}
    get Tc9crbool(){return this.tc9CrBool}
    set Tc9crbool(val){this.tc9CrBool = val}
    get Tc9crdouble(){return this.tc9CrDouble}
    set Tc9crdouble(val){this.tc9CrDouble = val}
    get Tc9crlongstr(){return this.tc9CrLongStr}
    set Tc9crlongstr(val){this.tc9CrLongStr = val}
    get Tc9crlovc(){return this.tc9CrLOVc}
    set Tc9crlovc(val){this.tc9CrLOVc = val}
    get Tc9crlove(){return this.tc9CrLOVe}
    set Tc9crlove(val){this.tc9CrLOVe = val}
    get Mdl0logicalDesignator(){return this.mdl0logical_designator}
    set Mdl0logicalDesignator(val){this.mdl0logical_designator = val}
    get Tc9crlovsint(){return this.tc9CrLOVsInt}
    set Tc9crlovsint(val){this.tc9CrLOVsInt = val}
    get Tc9crlovr(){return this.tc9CrLOVr}
    set Tc9crlovr(val){this.tc9CrLOVr = val}
    get Tc9crint(){return this.tc9CrInt}
    set Tc9crint(val){this.tc9CrInt = val}
    get Tc9crlovs(){return this.tc9CrLOVs}
    set Tc9crlovs(val){this.tc9CrLOVs = val}
    get Tc9crlovsdate(){return this.tc9CrLOVsDate}
    set Tc9crlovsdate(val){this.tc9CrLOVsDate = val}
    get Tc9crdate(){return this.tc9CrDate}
    set Tc9crdate(val){this.tc9CrDate = val}
    get Tc9prequired(){return this.tc9PRequired}
    set Tc9prequired(val){this.tc9PRequired = val}
    get Tc9crcharvla(){return this.tc9CrCharVLA}
    set Tc9crcharvla(val){this.tc9CrCharVLA = val}
};

SPLM.TCINDebugSession.TestUtilsCustomDECreationInput = class{
    constructor(flags,tc9CrLocal,tc9CrString,tc9CrChar,tc9CrBool,tc9CrDouble,tc9CrLongStr,tc9CrLOVc,tc9CrLOVe,mdl0logical_designator,tc9CrLOVsInt,tc9CrLOVr,tc9CrInt,tc9CrLOVs,tc9CrLOVsDate,tc9CrDate,tc9PRequired,tc9CrCharVLA){
        this.flags=flags;this.tc9CrLocal=tc9CrLocal;this.tc9CrString=tc9CrString;this.tc9CrChar=tc9CrChar;this.tc9CrBool=tc9CrBool;this.tc9CrDouble=tc9CrDouble;this.tc9CrLongStr=tc9CrLongStr;this.tc9CrLOVc=tc9CrLOVc;this.tc9CrLOVe=tc9CrLOVe;this.mdl0logical_designator=mdl0logical_designator;this.tc9CrLOVsInt=tc9CrLOVsInt;this.tc9CrLOVr=tc9CrLOVr;this.tc9CrInt=tc9CrInt;this.tc9CrLOVs=tc9CrLOVs;this.tc9CrLOVsDate=tc9CrLOVsDate;this.tc9CrDate=tc9CrDate;this.tc9PRequired=tc9PRequired;this.tc9CrCharVLA=tc9CrCharVLA;}
    get Flags(){if(this.flags === undefined) this.flags = new SPLM.TCINDebugSession.TestUtilsCustomDECreationInputFlags(); return this.flags}
    set Flags(val){this.flags = val}
    get Tc9crlocal(){return this.tc9CrLocal}
    set Tc9crlocal(val){this.tc9CrLocal = val}
    get Tc9crstring(){return this.tc9CrString}
    set Tc9crstring(val){this.tc9CrString = val}
    get Tc9crchar(){return this.tc9CrChar}
    set Tc9crchar(val){this.tc9CrChar = val}
    get Tc9crbool(){return this.tc9CrBool}
    set Tc9crbool(val){this.tc9CrBool = val}
    get Tc9crdouble(){return this.tc9CrDouble}
    set Tc9crdouble(val){this.tc9CrDouble = val}
    get Tc9crlongstr(){return this.tc9CrLongStr}
    set Tc9crlongstr(val){this.tc9CrLongStr = val}
    get Tc9crlovc(){return this.tc9CrLOVc}
    set Tc9crlovc(val){this.tc9CrLOVc = val}
    get Tc9crlove(){return this.tc9CrLOVe}
    set Tc9crlove(val){this.tc9CrLOVe = val}
    get Mdl0logicalDesignator(){return this.mdl0logical_designator}
    set Mdl0logicalDesignator(val){this.mdl0logical_designator = val}
    get Tc9crlovsint(){return this.tc9CrLOVsInt}
    set Tc9crlovsint(val){this.tc9CrLOVsInt = val}
    get Tc9crlovr(){return this.tc9CrLOVr}
    set Tc9crlovr(val){this.tc9CrLOVr = val}
    get Tc9crint(){return this.tc9CrInt}
    set Tc9crint(val){this.tc9CrInt = val}
    get Tc9crlovs(){return this.tc9CrLOVs}
    set Tc9crlovs(val){this.tc9CrLOVs = val}
    get Tc9crlovsdate(){return this.tc9CrLOVsDate}
    set Tc9crlovsdate(val){this.tc9CrLOVsDate = val}
    get Tc9crdate(){return this.tc9CrDate}
    set Tc9crdate(val){this.tc9CrDate = val}
    get Tc9prequired(){return this.tc9PRequired}
    set Tc9prequired(val){this.tc9PRequired = val}
    get Tc9crcharvla(){return this.tc9CrCharVLA}
    set Tc9crcharvla(val){this.tc9CrCharVLA = val}
};

SPLM.TCINDebugSession.TestUtilsCustomItemCreationInputFlags = class{
    constructor(iPRequired,iMPRequired,iRWOPRequired,iRMPRequired,iMCPBool,iMCPCharVLA,iPChar,iPDate,iPDouble,iPInt,iPLocal,iPLongStr,iPLOVc,iPLOVe,iPLOVs,iPLOVsDate,iPLOVsInt,iPString,iMMCPBool,iMPChar,iMPDate,iMPDouble,iMPInt,iMPLocal,iMPLongStr,iMPLOVc,iMPLOVsDate,iMPString,iMWOPCharVLA,iMWOPLOVs,iRCrBool,iRCrChar,iRCrCharVLA,iRCrDate,iRCrInt,iRCrLOVc,iRCrLOVr,iRCrLOVs,iRCrLOVsDate,iRCrLOVsInt,iRCrString,iRMCCrLocal,iRMCPLocal,iRPBool,iRPChar,iRPCharVLA,iRPDate,iRPInt,iRPLOVc,iRPLOVe,iRPLOVr,iRPLOVs,iRPLOVsDate,iRPLOVsInt,iRPString,iRWOCrLongStr,iRWOCrLOVe,iRMMCPString,iRMPChar,iRMPDate,iRMPDouble,iRMPInt,iRMPLocal,iRMPLOVe,iRMPLOVs,iRMPLOVsDate,iRMPLOVsInt,iRMWOPBool){
        this.iPRequired=iPRequired;this.iMPRequired=iMPRequired;this.iRWOPRequired=iRWOPRequired;this.iRMPRequired=iRMPRequired;this.iMCPBool=iMCPBool;this.iMCPCharVLA=iMCPCharVLA;this.iPChar=iPChar;this.iPDate=iPDate;this.iPDouble=iPDouble;this.iPInt=iPInt;this.iPLocal=iPLocal;this.iPLongStr=iPLongStr;this.iPLOVc=iPLOVc;this.iPLOVe=iPLOVe;this.iPLOVs=iPLOVs;this.iPLOVsDate=iPLOVsDate;this.iPLOVsInt=iPLOVsInt;this.iPString=iPString;this.iMMCPBool=iMMCPBool;this.iMPChar=iMPChar;this.iMPDate=iMPDate;this.iMPDouble=iMPDouble;this.iMPInt=iMPInt;this.iMPLocal=iMPLocal;this.iMPLongStr=iMPLongStr;this.iMPLOVc=iMPLOVc;this.iMPLOVsDate=iMPLOVsDate;this.iMPString=iMPString;this.iMWOPCharVLA=iMWOPCharVLA;this.iMWOPLOVs=iMWOPLOVs;this.iRCrBool=iRCrBool;this.iRCrChar=iRCrChar;this.iRCrCharVLA=iRCrCharVLA;this.iRCrDate=iRCrDate;this.iRCrInt=iRCrInt;this.iRCrLOVc=iRCrLOVc;this.iRCrLOVr=iRCrLOVr;this.iRCrLOVs=iRCrLOVs;this.iRCrLOVsDate=iRCrLOVsDate;this.iRCrLOVsInt=iRCrLOVsInt;this.iRCrString=iRCrString;this.iRMCCrLocal=iRMCCrLocal;this.iRMCPLocal=iRMCPLocal;this.iRPBool=iRPBool;this.iRPChar=iRPChar;this.iRPCharVLA=iRPCharVLA;this.iRPDate=iRPDate;this.iRPInt=iRPInt;this.iRPLOVc=iRPLOVc;this.iRPLOVe=iRPLOVe;this.iRPLOVr=iRPLOVr;this.iRPLOVs=iRPLOVs;this.iRPLOVsDate=iRPLOVsDate;this.iRPLOVsInt=iRPLOVsInt;this.iRPString=iRPString;this.iRWOCrLongStr=iRWOCrLongStr;this.iRWOCrLOVe=iRWOCrLOVe;this.iRMMCPString=iRMMCPString;this.iRMPChar=iRMPChar;this.iRMPDate=iRMPDate;this.iRMPDouble=iRMPDouble;this.iRMPInt=iRMPInt;this.iRMPLocal=iRMPLocal;this.iRMPLOVe=iRMPLOVe;this.iRMPLOVs=iRMPLOVs;this.iRMPLOVsDate=iRMPLOVsDate;this.iRMPLOVsInt=iRMPLOVsInt;this.iRMWOPBool=iRMWOPBool;}
    get Iprequired(){return this.iPRequired}
    set Iprequired(val){this.iPRequired = val}
    get Imprequired(){return this.iMPRequired}
    set Imprequired(val){this.iMPRequired = val}
    get Irwoprequired(){return this.iRWOPRequired}
    set Irwoprequired(val){this.iRWOPRequired = val}
    get Irmprequired(){return this.iRMPRequired}
    set Irmprequired(val){this.iRMPRequired = val}
    get Imcpbool(){return this.iMCPBool}
    set Imcpbool(val){this.iMCPBool = val}
    get Imcpcharvla(){return this.iMCPCharVLA}
    set Imcpcharvla(val){this.iMCPCharVLA = val}
    get Ipchar(){return this.iPChar}
    set Ipchar(val){this.iPChar = val}
    get Ipdate(){return this.iPDate}
    set Ipdate(val){this.iPDate = val}
    get Ipdouble(){return this.iPDouble}
    set Ipdouble(val){this.iPDouble = val}
    get Ipint(){return this.iPInt}
    set Ipint(val){this.iPInt = val}
    get Iplocal(){return this.iPLocal}
    set Iplocal(val){this.iPLocal = val}
    get Iplongstr(){return this.iPLongStr}
    set Iplongstr(val){this.iPLongStr = val}
    get Iplovc(){return this.iPLOVc}
    set Iplovc(val){this.iPLOVc = val}
    get Iplove(){return this.iPLOVe}
    set Iplove(val){this.iPLOVe = val}
    get Iplovs(){return this.iPLOVs}
    set Iplovs(val){this.iPLOVs = val}
    get Iplovsdate(){return this.iPLOVsDate}
    set Iplovsdate(val){this.iPLOVsDate = val}
    get Iplovsint(){return this.iPLOVsInt}
    set Iplovsint(val){this.iPLOVsInt = val}
    get Ipstring(){return this.iPString}
    set Ipstring(val){this.iPString = val}
    get Immcpbool(){return this.iMMCPBool}
    set Immcpbool(val){this.iMMCPBool = val}
    get Impchar(){return this.iMPChar}
    set Impchar(val){this.iMPChar = val}
    get Impdate(){return this.iMPDate}
    set Impdate(val){this.iMPDate = val}
    get Impdouble(){return this.iMPDouble}
    set Impdouble(val){this.iMPDouble = val}
    get Impint(){return this.iMPInt}
    set Impint(val){this.iMPInt = val}
    get Implocal(){return this.iMPLocal}
    set Implocal(val){this.iMPLocal = val}
    get Implongstr(){return this.iMPLongStr}
    set Implongstr(val){this.iMPLongStr = val}
    get Implovc(){return this.iMPLOVc}
    set Implovc(val){this.iMPLOVc = val}
    get Implovsdate(){return this.iMPLOVsDate}
    set Implovsdate(val){this.iMPLOVsDate = val}
    get Impstring(){return this.iMPString}
    set Impstring(val){this.iMPString = val}
    get Imwopcharvla(){return this.iMWOPCharVLA}
    set Imwopcharvla(val){this.iMWOPCharVLA = val}
    get Imwoplovs(){return this.iMWOPLOVs}
    set Imwoplovs(val){this.iMWOPLOVs = val}
    get Ircrbool(){return this.iRCrBool}
    set Ircrbool(val){this.iRCrBool = val}
    get Ircrchar(){return this.iRCrChar}
    set Ircrchar(val){this.iRCrChar = val}
    get Ircrcharvla(){return this.iRCrCharVLA}
    set Ircrcharvla(val){this.iRCrCharVLA = val}
    get Ircrdate(){return this.iRCrDate}
    set Ircrdate(val){this.iRCrDate = val}
    get Ircrint(){return this.iRCrInt}
    set Ircrint(val){this.iRCrInt = val}
    get Ircrlovc(){return this.iRCrLOVc}
    set Ircrlovc(val){this.iRCrLOVc = val}
    get Ircrlovr(){return this.iRCrLOVr}
    set Ircrlovr(val){this.iRCrLOVr = val}
    get Ircrlovs(){return this.iRCrLOVs}
    set Ircrlovs(val){this.iRCrLOVs = val}
    get Ircrlovsdate(){return this.iRCrLOVsDate}
    set Ircrlovsdate(val){this.iRCrLOVsDate = val}
    get Ircrlovsint(){return this.iRCrLOVsInt}
    set Ircrlovsint(val){this.iRCrLOVsInt = val}
    get Ircrstring(){return this.iRCrString}
    set Ircrstring(val){this.iRCrString = val}
    get Irmccrlocal(){return this.iRMCCrLocal}
    set Irmccrlocal(val){this.iRMCCrLocal = val}
    get Irmcplocal(){return this.iRMCPLocal}
    set Irmcplocal(val){this.iRMCPLocal = val}
    get Irpbool(){return this.iRPBool}
    set Irpbool(val){this.iRPBool = val}
    get Irpchar(){return this.iRPChar}
    set Irpchar(val){this.iRPChar = val}
    get Irpcharvla(){return this.iRPCharVLA}
    set Irpcharvla(val){this.iRPCharVLA = val}
    get Irpdate(){return this.iRPDate}
    set Irpdate(val){this.iRPDate = val}
    get Irpint(){return this.iRPInt}
    set Irpint(val){this.iRPInt = val}
    get Irplovc(){return this.iRPLOVc}
    set Irplovc(val){this.iRPLOVc = val}
    get Irplove(){return this.iRPLOVe}
    set Irplove(val){this.iRPLOVe = val}
    get Irplovr(){return this.iRPLOVr}
    set Irplovr(val){this.iRPLOVr = val}
    get Irplovs(){return this.iRPLOVs}
    set Irplovs(val){this.iRPLOVs = val}
    get Irplovsdate(){return this.iRPLOVsDate}
    set Irplovsdate(val){this.iRPLOVsDate = val}
    get Irplovsint(){return this.iRPLOVsInt}
    set Irplovsint(val){this.iRPLOVsInt = val}
    get Irpstring(){return this.iRPString}
    set Irpstring(val){this.iRPString = val}
    get Irwocrlongstr(){return this.iRWOCrLongStr}
    set Irwocrlongstr(val){this.iRWOCrLongStr = val}
    get Irwocrlove(){return this.iRWOCrLOVe}
    set Irwocrlove(val){this.iRWOCrLOVe = val}
    get Irmmcpstring(){return this.iRMMCPString}
    set Irmmcpstring(val){this.iRMMCPString = val}
    get Irmpchar(){return this.iRMPChar}
    set Irmpchar(val){this.iRMPChar = val}
    get Irmpdate(){return this.iRMPDate}
    set Irmpdate(val){this.iRMPDate = val}
    get Irmpdouble(){return this.iRMPDouble}
    set Irmpdouble(val){this.iRMPDouble = val}
    get Irmpint(){return this.iRMPInt}
    set Irmpint(val){this.iRMPInt = val}
    get Irmplocal(){return this.iRMPLocal}
    set Irmplocal(val){this.iRMPLocal = val}
    get Irmplove(){return this.iRMPLOVe}
    set Irmplove(val){this.iRMPLOVe = val}
    get Irmplovs(){return this.iRMPLOVs}
    set Irmplovs(val){this.iRMPLOVs = val}
    get Irmplovsdate(){return this.iRMPLOVsDate}
    set Irmplovsdate(val){this.iRMPLOVsDate = val}
    get Irmplovsint(){return this.iRMPLOVsInt}
    set Irmplovsint(val){this.iRMPLOVsInt = val}
    get Irmwopbool(){return this.iRMWOPBool}
    set Irmwopbool(val){this.iRMWOPBool = val}
};

SPLM.TCINDebugSession.TestUtilsCustomItemCreationInput = class{
    constructor(flags,iPRequired,iMPRequired,iRWOPRequired,iRMPRequired,iMCPBool,iMCPCharVLA,iPChar,iPDate,iPDouble,iPInt,iPLocal,iPLongStr,iPLOVc,iPLOVe,iPLOVs,iPLOVsDate,iPLOVsInt,iPString,iMMCPBool,iMPChar,iMPDate,iMPDouble,iMPInt,iMPLocal,iMPLongStr,iMPLOVc,iMPLOVsDate,iMPString,iMWOPCharVLA,iMWOPLOVs,iRCrBool,iRCrChar,iRCrCharVLA,iRCrDate,iRCrInt,iRCrLOVc,iRCrLOVr,iRCrLOVs,iRCrLOVsDate,iRCrLOVsInt,iRCrString,iRMCCrLocal,iRMCPLocal,iRPBool,iRPChar,iRPCharVLA,iRPDate,iRPInt,iRPLOVc,iRPLOVe,iRPLOVr,iRPLOVs,iRPLOVsDate,iRPLOVsInt,iRPString,iRWOCrLongStr,iRWOCrLOVe,iRMMCPString,iRMPChar,iRMPDate,iRMPDouble,iRMPInt,iRMPLocal,iRMPLOVe,iRMPLOVs,iRMPLOVsDate,iRMPLOVsInt,iRMWOPBool){
        this.flags=flags;this.iPRequired=iPRequired;this.iMPRequired=iMPRequired;this.iRWOPRequired=iRWOPRequired;this.iRMPRequired=iRMPRequired;this.iMCPBool=iMCPBool;this.iMCPCharVLA=iMCPCharVLA;this.iPChar=iPChar;this.iPDate=iPDate;this.iPDouble=iPDouble;this.iPInt=iPInt;this.iPLocal=iPLocal;this.iPLongStr=iPLongStr;this.iPLOVc=iPLOVc;this.iPLOVe=iPLOVe;this.iPLOVs=iPLOVs;this.iPLOVsDate=iPLOVsDate;this.iPLOVsInt=iPLOVsInt;this.iPString=iPString;this.iMMCPBool=iMMCPBool;this.iMPChar=iMPChar;this.iMPDate=iMPDate;this.iMPDouble=iMPDouble;this.iMPInt=iMPInt;this.iMPLocal=iMPLocal;this.iMPLongStr=iMPLongStr;this.iMPLOVc=iMPLOVc;this.iMPLOVsDate=iMPLOVsDate;this.iMPString=iMPString;this.iMWOPCharVLA=iMWOPCharVLA;this.iMWOPLOVs=iMWOPLOVs;this.iRCrBool=iRCrBool;this.iRCrChar=iRCrChar;this.iRCrCharVLA=iRCrCharVLA;this.iRCrDate=iRCrDate;this.iRCrInt=iRCrInt;this.iRCrLOVc=iRCrLOVc;this.iRCrLOVr=iRCrLOVr;this.iRCrLOVs=iRCrLOVs;this.iRCrLOVsDate=iRCrLOVsDate;this.iRCrLOVsInt=iRCrLOVsInt;this.iRCrString=iRCrString;this.iRMCCrLocal=iRMCCrLocal;this.iRMCPLocal=iRMCPLocal;this.iRPBool=iRPBool;this.iRPChar=iRPChar;this.iRPCharVLA=iRPCharVLA;this.iRPDate=iRPDate;this.iRPInt=iRPInt;this.iRPLOVc=iRPLOVc;this.iRPLOVe=iRPLOVe;this.iRPLOVr=iRPLOVr;this.iRPLOVs=iRPLOVs;this.iRPLOVsDate=iRPLOVsDate;this.iRPLOVsInt=iRPLOVsInt;this.iRPString=iRPString;this.iRWOCrLongStr=iRWOCrLongStr;this.iRWOCrLOVe=iRWOCrLOVe;this.iRMMCPString=iRMMCPString;this.iRMPChar=iRMPChar;this.iRMPDate=iRMPDate;this.iRMPDouble=iRMPDouble;this.iRMPInt=iRMPInt;this.iRMPLocal=iRMPLocal;this.iRMPLOVe=iRMPLOVe;this.iRMPLOVs=iRMPLOVs;this.iRMPLOVsDate=iRMPLOVsDate;this.iRMPLOVsInt=iRMPLOVsInt;this.iRMWOPBool=iRMWOPBool;}
    get Flags(){if(this.flags === undefined) this.flags = new SPLM.TCINDebugSession.TestUtilsCustomItemCreationInputFlags(); return this.flags}
    set Flags(val){this.flags = val}
    get Iprequired(){return this.iPRequired}
    set Iprequired(val){this.iPRequired = val}
    get Imprequired(){return this.iMPRequired}
    set Imprequired(val){this.iMPRequired = val}
    get Irwoprequired(){return this.iRWOPRequired}
    set Irwoprequired(val){this.iRWOPRequired = val}
    get Irmprequired(){return this.iRMPRequired}
    set Irmprequired(val){this.iRMPRequired = val}
    get Imcpbool(){return this.iMCPBool}
    set Imcpbool(val){this.iMCPBool = val}
    get Imcpcharvla(){return this.iMCPCharVLA}
    set Imcpcharvla(val){this.iMCPCharVLA = val}
    get Ipchar(){return this.iPChar}
    set Ipchar(val){this.iPChar = val}
    get Ipdate(){return this.iPDate}
    set Ipdate(val){this.iPDate = val}
    get Ipdouble(){return this.iPDouble}
    set Ipdouble(val){this.iPDouble = val}
    get Ipint(){return this.iPInt}
    set Ipint(val){this.iPInt = val}
    get Iplocal(){return this.iPLocal}
    set Iplocal(val){this.iPLocal = val}
    get Iplongstr(){return this.iPLongStr}
    set Iplongstr(val){this.iPLongStr = val}
    get Iplovc(){return this.iPLOVc}
    set Iplovc(val){this.iPLOVc = val}
    get Iplove(){return this.iPLOVe}
    set Iplove(val){this.iPLOVe = val}
    get Iplovs(){return this.iPLOVs}
    set Iplovs(val){this.iPLOVs = val}
    get Iplovsdate(){return this.iPLOVsDate}
    set Iplovsdate(val){this.iPLOVsDate = val}
    get Iplovsint(){return this.iPLOVsInt}
    set Iplovsint(val){this.iPLOVsInt = val}
    get Ipstring(){return this.iPString}
    set Ipstring(val){this.iPString = val}
    get Immcpbool(){return this.iMMCPBool}
    set Immcpbool(val){this.iMMCPBool = val}
    get Impchar(){return this.iMPChar}
    set Impchar(val){this.iMPChar = val}
    get Impdate(){return this.iMPDate}
    set Impdate(val){this.iMPDate = val}
    get Impdouble(){return this.iMPDouble}
    set Impdouble(val){this.iMPDouble = val}
    get Impint(){return this.iMPInt}
    set Impint(val){this.iMPInt = val}
    get Implocal(){return this.iMPLocal}
    set Implocal(val){this.iMPLocal = val}
    get Implongstr(){return this.iMPLongStr}
    set Implongstr(val){this.iMPLongStr = val}
    get Implovc(){return this.iMPLOVc}
    set Implovc(val){this.iMPLOVc = val}
    get Implovsdate(){return this.iMPLOVsDate}
    set Implovsdate(val){this.iMPLOVsDate = val}
    get Impstring(){return this.iMPString}
    set Impstring(val){this.iMPString = val}
    get Imwopcharvla(){return this.iMWOPCharVLA}
    set Imwopcharvla(val){this.iMWOPCharVLA = val}
    get Imwoplovs(){return this.iMWOPLOVs}
    set Imwoplovs(val){this.iMWOPLOVs = val}
    get Ircrbool(){return this.iRCrBool}
    set Ircrbool(val){this.iRCrBool = val}
    get Ircrchar(){return this.iRCrChar}
    set Ircrchar(val){this.iRCrChar = val}
    get Ircrcharvla(){return this.iRCrCharVLA}
    set Ircrcharvla(val){this.iRCrCharVLA = val}
    get Ircrdate(){return this.iRCrDate}
    set Ircrdate(val){this.iRCrDate = val}
    get Ircrint(){return this.iRCrInt}
    set Ircrint(val){this.iRCrInt = val}
    get Ircrlovc(){return this.iRCrLOVc}
    set Ircrlovc(val){this.iRCrLOVc = val}
    get Ircrlovr(){return this.iRCrLOVr}
    set Ircrlovr(val){this.iRCrLOVr = val}
    get Ircrlovs(){return this.iRCrLOVs}
    set Ircrlovs(val){this.iRCrLOVs = val}
    get Ircrlovsdate(){return this.iRCrLOVsDate}
    set Ircrlovsdate(val){this.iRCrLOVsDate = val}
    get Ircrlovsint(){return this.iRCrLOVsInt}
    set Ircrlovsint(val){this.iRCrLOVsInt = val}
    get Ircrstring(){return this.iRCrString}
    set Ircrstring(val){this.iRCrString = val}
    get Irmccrlocal(){return this.iRMCCrLocal}
    set Irmccrlocal(val){this.iRMCCrLocal = val}
    get Irmcplocal(){return this.iRMCPLocal}
    set Irmcplocal(val){this.iRMCPLocal = val}
    get Irpbool(){return this.iRPBool}
    set Irpbool(val){this.iRPBool = val}
    get Irpchar(){return this.iRPChar}
    set Irpchar(val){this.iRPChar = val}
    get Irpcharvla(){return this.iRPCharVLA}
    set Irpcharvla(val){this.iRPCharVLA = val}
    get Irpdate(){return this.iRPDate}
    set Irpdate(val){this.iRPDate = val}
    get Irpint(){return this.iRPInt}
    set Irpint(val){this.iRPInt = val}
    get Irplovc(){return this.iRPLOVc}
    set Irplovc(val){this.iRPLOVc = val}
    get Irplove(){return this.iRPLOVe}
    set Irplove(val){this.iRPLOVe = val}
    get Irplovr(){return this.iRPLOVr}
    set Irplovr(val){this.iRPLOVr = val}
    get Irplovs(){return this.iRPLOVs}
    set Irplovs(val){this.iRPLOVs = val}
    get Irplovsdate(){return this.iRPLOVsDate}
    set Irplovsdate(val){this.iRPLOVsDate = val}
    get Irplovsint(){return this.iRPLOVsInt}
    set Irplovsint(val){this.iRPLOVsInt = val}
    get Irpstring(){return this.iRPString}
    set Irpstring(val){this.iRPString = val}
    get Irwocrlongstr(){return this.iRWOCrLongStr}
    set Irwocrlongstr(val){this.iRWOCrLongStr = val}
    get Irwocrlove(){return this.iRWOCrLOVe}
    set Irwocrlove(val){this.iRWOCrLOVe = val}
    get Irmmcpstring(){return this.iRMMCPString}
    set Irmmcpstring(val){this.iRMMCPString = val}
    get Irmpchar(){return this.iRMPChar}
    set Irmpchar(val){this.iRMPChar = val}
    get Irmpdate(){return this.iRMPDate}
    set Irmpdate(val){this.iRMPDate = val}
    get Irmpdouble(){return this.iRMPDouble}
    set Irmpdouble(val){this.iRMPDouble = val}
    get Irmpint(){return this.iRMPInt}
    set Irmpint(val){this.iRMPInt = val}
    get Irmplocal(){return this.iRMPLocal}
    set Irmplocal(val){this.iRMPLocal = val}
    get Irmplove(){return this.iRMPLOVe}
    set Irmplove(val){this.iRMPLOVe = val}
    get Irmplovs(){return this.iRMPLOVs}
    set Irmplovs(val){this.iRMPLOVs = val}
    get Irmplovsdate(){return this.iRMPLOVsDate}
    set Irmplovsdate(val){this.iRMPLOVsDate = val}
    get Irmplovsint(){return this.iRMPLOVsInt}
    set Irmplovsint(val){this.iRMPLOVsInt = val}
    get Irmwopbool(){return this.iRMWOPBool}
    set Irmwopbool(val){this.iRMWOPBool = val}
};

SPLM.TCINDebugSession.TestUtilsCustomWorksetCreationInputFlags = class{
    constructor(flags){
        this.flags=flags;}
    get Flags(){if(this.flags === undefined) this.flags = new SPLM.TCINDebugSession.TestUtilsCustomItemCreationInputFlags(); return this.flags}
    set Flags(val){this.flags = val}
};

SPLM.TCINDebugSession.TestUtilsCustomWorksetCreationInput = class{
    constructor(workSetType,worksetId,worksetRev,templateName,worksetFlags,customItemCreationInput){
        this.workSetType=workSetType;this.worksetId=worksetId;this.worksetRev=worksetRev;this.templateName=templateName;this.worksetFlags=worksetFlags;this.customItemCreationInput=customItemCreationInput;}
    get Worksettype(){return this.workSetType}
    set Worksettype(val){this.workSetType = val}
    get Worksetid(){return this.worksetId}
    set Worksetid(val){this.worksetId = val}
    get Worksetrev(){return this.worksetRev}
    set Worksetrev(val){this.worksetRev = val}
    get Templatename(){return this.templateName}
    set Templatename(val){this.templateName = val}
    get Worksetflags(){if(this.worksetFlags === undefined) this.worksetFlags = new SPLM.TCINDebugSession.TestUtilsCustomWorksetCreationInputFlags(); return this.worksetFlags}
    set Worksetflags(val){this.worksetFlags = val}
    get Customitemcreationinput(){if(this.customItemCreationInput === undefined) this.customItemCreationInput = new SPLM.TCINDebugSession.TestUtilsCustomItemCreationInput(); return this.customItemCreationInput}
    set Customitemcreationinput(val){this.customItemCreationInput = val}
};

SPLM.TCINDebugSession.TestUtilsCustomShapeItemCreationInputFlags = class{
    constructor(flags,iRCrDouble){
        this.flags=flags;this.iRCrDouble=iRCrDouble;}
    get Flags(){if(this.flags === undefined) this.flags = new SPLM.TCINDebugSession.TestUtilsCustomItemCreationInputFlags(); return this.flags}
    set Flags(val){this.flags = val}
    get Ircrdouble(){return this.iRCrDouble}
    set Ircrdouble(val){this.iRCrDouble = val}
};

SPLM.TCINDebugSession.TestUtilsCustomShapeItemCreationInput = class{
    constructor(itemType,itemId,itemRev,templateName,iRCrDouble,shapeItemFlags,customItemCreationInput){
        this.itemType=itemType;this.itemId=itemId;this.itemRev=itemRev;this.templateName=templateName;this.iRCrDouble=iRCrDouble;this.shapeItemFlags=shapeItemFlags;this.customItemCreationInput=customItemCreationInput;}
    get Itemtype(){return this.itemType}
    set Itemtype(val){this.itemType = val}
    get Itemid(){return this.itemId}
    set Itemid(val){this.itemId = val}
    get Itemrev(){return this.itemRev}
    set Itemrev(val){this.itemRev = val}
    get Templatename(){return this.templateName}
    set Templatename(val){this.templateName = val}
    get Ircrdouble(){return this.iRCrDouble}
    set Ircrdouble(val){this.iRCrDouble = val}
    get Shapeitemflags(){if(this.shapeItemFlags === undefined) this.shapeItemFlags = new SPLM.TCINDebugSession.TestUtilsCustomShapeItemCreationInputFlags(); return this.shapeItemFlags}
    set Shapeitemflags(val){this.shapeItemFlags = val}
    get Customitemcreationinput(){if(this.customItemCreationInput === undefined) this.customItemCreationInput = new SPLM.TCINDebugSession.TestUtilsCustomItemCreationInput(); return this.customItemCreationInput}
    set Customitemcreationinput(val){this.customItemCreationInput = val}
};

SPLM.TCINDebugSession.TestUtilsShapeDECreationInput = class{
    constructor(subsetName,designElementId,deApp,templateFileName,designElementName,designElementDescription,typeTemplateString,referenceSet,layer,isCustomDE,customDECreationInput,isCustomShapeItem,customShapeItemCreationInput,templatePresentationName,applicationName,itemType,designElementType,designElementState){
        this.subsetName=subsetName;this.designElementId=designElementId;this.deApp=deApp;this.templateFileName=templateFileName;this.designElementName=designElementName;this.designElementDescription=designElementDescription;this.typeTemplateString=typeTemplateString;this.referenceSet=referenceSet;this.layer=layer;this.isCustomDE=isCustomDE;this.customDECreationInput=customDECreationInput;this.isCustomShapeItem=isCustomShapeItem;this.customShapeItemCreationInput=customShapeItemCreationInput;this.templatePresentationName=templatePresentationName;this.applicationName=applicationName;this.itemType=itemType;this.designElementType=designElementType;this.designElementState=designElementState;}
    get Subsetname(){return this.subsetName}
    set Subsetname(val){this.subsetName = val}
    get Designelementid(){return this.designElementId}
    set Designelementid(val){this.designElementId = val}
    get Deapp(){return this.deApp}
    set Deapp(val){this.deApp = val}
    get Templatefilename(){return this.templateFileName}
    set Templatefilename(val){this.templateFileName = val}
    get Designelementname(){return this.designElementName}
    set Designelementname(val){this.designElementName = val}
    get Designelementdescription(){return this.designElementDescription}
    set Designelementdescription(val){this.designElementDescription = val}
    get Typetemplatestring(){return this.typeTemplateString}
    set Typetemplatestring(val){this.typeTemplateString = val}
    get Referenceset(){return this.referenceSet}
    set Referenceset(val){this.referenceSet = val}
    get Layer(){return this.layer}
    set Layer(val){this.layer = val}
    get Iscustomde(){return this.isCustomDE}
    set Iscustomde(val){this.isCustomDE = val}
    get Customdecreationinput(){if(this.customDECreationInput === undefined) this.customDECreationInput = new SPLM.TCINDebugSession.TestUtilsCustomDECreationInput(); return this.customDECreationInput}
    set Customdecreationinput(val){this.customDECreationInput = val}
    get Iscustomshapeitem(){return this.isCustomShapeItem}
    set Iscustomshapeitem(val){this.isCustomShapeItem = val}
    get Customshapeitemcreationinput(){if(this.customShapeItemCreationInput === undefined) this.customShapeItemCreationInput = new SPLM.TCINDebugSession.TestUtilsCustomShapeItemCreationInput(); return this.customShapeItemCreationInput}
    set Customshapeitemcreationinput(val){this.customShapeItemCreationInput = val}
    get Templatepresentationname(){return this.templatePresentationName}
    set Templatepresentationname(val){this.templatePresentationName = val}
    get Applicationname(){return this.applicationName}
    set Applicationname(val){this.applicationName = val}
    get Itemtype(){return this.itemType}
    set Itemtype(val){this.itemType = val}
    get Designelementtype(){return this.designElementType}
    set Designelementtype(val){this.designElementType = val}
    get Designelementstate(){return this.designElementState}
    set Designelementstate(val){this.designElementState = val}
};

SPLM.TCINDebugSession.TestUtilsPromissoryDECreationInput = class{
    constructor(subsetName,designElementId,deApp,templateFileName,designElementName,designElementDescription,typeTemplateString,isCustomDE,customDECreationInput,templatePresentationName,applicationName,itemType,designElementType,designElementState){
        this.subsetName=subsetName;this.designElementId=designElementId;this.deApp=deApp;this.templateFileName=templateFileName;this.designElementName=designElementName;this.designElementDescription=designElementDescription;this.typeTemplateString=typeTemplateString;this.isCustomDE=isCustomDE;this.customDECreationInput=customDECreationInput;this.templatePresentationName=templatePresentationName;this.applicationName=applicationName;this.itemType=itemType;this.designElementType=designElementType;this.designElementState=designElementState;}
    get Subsetname(){return this.subsetName}
    set Subsetname(val){this.subsetName = val}
    get Designelementid(){return this.designElementId}
    set Designelementid(val){this.designElementId = val}
    get Deapp(){return this.deApp}
    set Deapp(val){this.deApp = val}
    get Templatefilename(){return this.templateFileName}
    set Templatefilename(val){this.templateFileName = val}
    get Designelementname(){return this.designElementName}
    set Designelementname(val){this.designElementName = val}
    get Designelementdescription(){return this.designElementDescription}
    set Designelementdescription(val){this.designElementDescription = val}
    get Typetemplatestring(){return this.typeTemplateString}
    set Typetemplatestring(val){this.typeTemplateString = val}
    get Iscustomde(){return this.isCustomDE}
    set Iscustomde(val){this.isCustomDE = val}
    get Customdecreationinput(){if(this.customDECreationInput === undefined) this.customDECreationInput = new SPLM.TCINDebugSession.TestUtilsCustomDECreationInput(); return this.customDECreationInput}
    set Customdecreationinput(val){this.customDECreationInput = val}
    get Templatepresentationname(){return this.templatePresentationName}
    set Templatepresentationname(val){this.templatePresentationName = val}
    get Applicationname(){return this.applicationName}
    set Applicationname(val){this.applicationName = val}
    get Itemtype(){return this.itemType}
    set Itemtype(val){this.itemType = val}
    get Designelementtype(){return this.designElementType}
    set Designelementtype(val){this.designElementType = val}
    get Designelementstate(){return this.designElementState}
    set Designelementstate(val){this.designElementState = val}
};

SPLM.TCINDebugSession.TestUtilsReuseDECreationInput = class{
    constructor(subsetName,partToUse,designElementId,deApp,templateFileName,designElementName,designElementDescription,typeTemplateString,referenceSet,layer,positionX,positionY,positionZ,partAlreadyLoaded,partHasNoDataset,isCustomDE,customDECreationInput,templatePresentationName,applicationName,itemType,designElementType,designElementState){
        this.subsetName=subsetName;this.partToUse=partToUse;this.designElementId=designElementId;this.deApp=deApp;this.templateFileName=templateFileName;this.designElementName=designElementName;this.designElementDescription=designElementDescription;this.typeTemplateString=typeTemplateString;this.referenceSet=referenceSet;this.layer=layer;this.positionX=positionX;this.positionY=positionY;this.positionZ=positionZ;this.partAlreadyLoaded=partAlreadyLoaded;this.partHasNoDataset=partHasNoDataset;this.isCustomDE=isCustomDE;this.customDECreationInput=customDECreationInput;this.templatePresentationName=templatePresentationName;this.applicationName=applicationName;this.itemType=itemType;this.designElementType=designElementType;this.designElementState=designElementState;}
    get Subsetname(){return this.subsetName}
    set Subsetname(val){this.subsetName = val}
    get Parttouse(){return this.partToUse}
    set Parttouse(val){this.partToUse = val}
    get Designelementid(){return this.designElementId}
    set Designelementid(val){this.designElementId = val}
    get Deapp(){return this.deApp}
    set Deapp(val){this.deApp = val}
    get Templatefilename(){return this.templateFileName}
    set Templatefilename(val){this.templateFileName = val}
    get Designelementname(){return this.designElementName}
    set Designelementname(val){this.designElementName = val}
    get Designelementdescription(){return this.designElementDescription}
    set Designelementdescription(val){this.designElementDescription = val}
    get Typetemplatestring(){return this.typeTemplateString}
    set Typetemplatestring(val){this.typeTemplateString = val}
    get Referenceset(){return this.referenceSet}
    set Referenceset(val){this.referenceSet = val}
    get Layer(){return this.layer}
    set Layer(val){this.layer = val}
    get Positionx(){return this.positionX}
    set Positionx(val){this.positionX = val}
    get Positiony(){return this.positionY}
    set Positiony(val){this.positionY = val}
    get Positionz(){return this.positionZ}
    set Positionz(val){this.positionZ = val}
    get Partalreadyloaded(){return this.partAlreadyLoaded}
    set Partalreadyloaded(val){this.partAlreadyLoaded = val}
    get Parthasnodataset(){return this.partHasNoDataset}
    set Parthasnodataset(val){this.partHasNoDataset = val}
    get Iscustomde(){return this.isCustomDE}
    set Iscustomde(val){this.isCustomDE = val}
    get Customdecreationinput(){if(this.customDECreationInput === undefined) this.customDECreationInput = new SPLM.TCINDebugSession.TestUtilsCustomDECreationInput(); return this.customDECreationInput}
    set Customdecreationinput(val){this.customDECreationInput = val}
    get Templatepresentationname(){return this.templatePresentationName}
    set Templatepresentationname(val){this.templatePresentationName = val}
    get Applicationname(){return this.applicationName}
    set Applicationname(val){this.applicationName = val}
    get Itemtype(){return this.itemType}
    set Itemtype(val){this.itemType = val}
    get Designelementtype(){return this.designElementType}
    set Designelementtype(val){this.designElementType = val}
    get Designelementstate(){return this.designElementState}
    set Designelementstate(val){this.designElementState = val}
};

SPLM.TCINDebugSession.TestUtilsSubsetCreationInput = class{
    constructor(collabDesignID,worksetName,subsetName,subsetDescription,subsetRevisionRule,subsetSetEffectivity,subsetEffectivityUnitsRange){
        this.collabDesignID=collabDesignID;this.worksetName=worksetName;this.subsetName=subsetName;this.subsetDescription=subsetDescription;this.subsetRevisionRule=subsetRevisionRule;this.subsetSetEffectivity=subsetSetEffectivity;this.subsetEffectivityUnitsRange=subsetEffectivityUnitsRange;}
    get Collabdesignid(){return this.collabDesignID}
    set Collabdesignid(val){this.collabDesignID = val}
    get Worksetname(){return this.worksetName}
    set Worksetname(val){this.worksetName = val}
    get Subsetname(){return this.subsetName}
    set Subsetname(val){this.subsetName = val}
    get Subsetdescription(){return this.subsetDescription}
    set Subsetdescription(val){this.subsetDescription = val}
    get Subsetrevisionrule(){return this.subsetRevisionRule}
    set Subsetrevisionrule(val){this.subsetRevisionRule = val}
    get Subsetseteffectivity(){return this.subsetSetEffectivity}
    set Subsetseteffectivity(val){this.subsetSetEffectivity = val}
    get Subseteffectivityunitsrange(){return this.subsetEffectivityUnitsRange}
    set Subseteffectivityunitsrange(val){this.subsetEffectivityUnitsRange = val}
};

SPLM.TCINDebugSession.TestUtilsAttributeInput = class{
    constructor(attributeTitle,attributeCategory,attributeType,isNewAttribute,isArray,boolValues,intValues,numberValues,stringValues,dateValues){
        this.attributeTitle=attributeTitle;this.attributeCategory=attributeCategory;this.attributeType=attributeType;this.isNewAttribute=isNewAttribute;this.isArray=isArray;this.boolValues=boolValues;this.intValues=intValues;this.numberValues=numberValues;this.stringValues=stringValues;this.dateValues=dateValues;}
    get Attributetitle(){return this.attributeTitle}
    set Attributetitle(val){this.attributeTitle = val}
    get Attributecategory(){return this.attributeCategory}
    set Attributecategory(val){this.attributeCategory = val}
    get Attributetype(){return this.attributeType}
    set Attributetype(val){this.attributeType = val}
    get Isnewattribute(){return this.isNewAttribute}
    set Isnewattribute(val){this.isNewAttribute = val}
    get Isarray(){return this.isArray}
    set Isarray(val){this.isArray = val}
    get Boolvalues(){return this.boolValues}
    set Boolvalues(val){this.boolValues = val}
    get Intvalues(){return this.intValues}
    set Intvalues(val){this.intValues = val}
    get Numbervalues(){return this.numberValues}
    set Numbervalues(val){this.numberValues = val}
    get Stringvalues(){return this.stringValues}
    set Stringvalues(val){this.stringValues = val}
    get Datevalues(){return this.dateValues}
    set Datevalues(val){this.dateValues = val}
};

SPLM.TCINDebugSession.TestUtilsProjectInputS = class{
    constructor(projectName,assignmentState){
        this.projectName=projectName;this.assignmentState=assignmentState;}
    get Projectname(){return this.projectName}
    set Projectname(val){this.projectName = val}
    get Assignmentstate(){return this.assignmentState}
    set Assignmentstate(val){this.assignmentState = val}
};

SPLM.TCINDebugSession.CloneNumberingRule = class{
    constructor(prefix,suffix,stringToReplace,replaceWithString,renumberString){
        this.prefix=prefix;this.suffix=suffix;this.stringToReplace=stringToReplace;this.replaceWithString=replaceWithString;this.renumberString=renumberString;}
    get Prefix(){return this.prefix}
    set Prefix(val){this.prefix = val}
    get Suffix(){return this.suffix}
    set Suffix(val){this.suffix = val}
    get Stringtoreplace(){return this.stringToReplace}
    set Stringtoreplace(val){this.stringToReplace = val}
    get Replacewithstring(){return this.replaceWithString}
    set Replacewithstring(val){this.replaceWithString = val}
    get Renumberstring(){return this.renumberString}
    set Renumberstring(val){this.renumberString = val}
};

SPLM.TCINDebugSession.PerformCopyOptions = class{
    constructor(defaultAction,numberingSource,conversionRule,numberingRule,destinationFolder,includeComponentParts,copyDrawingRelations,copyCaeRelations,copyCaeRelationOption,copyAssociatedFiles,copySpecification,copyManifestation,copyAltrep,copyCaeMotion,assignAlternateIds,defaultAlternateIdContext,defaultAlternateIdType,outputLogFile,attachLogFile,retainOwnership,defaultOwningUser,defaultOwningGroup,defaultChangeNotice){
        this.defaultAction=defaultAction;this.numberingSource=numberingSource;this.conversionRule=conversionRule;this.numberingRule=numberingRule;this.destinationFolder=destinationFolder;this.includeComponentParts=includeComponentParts;this.copyDrawingRelations=copyDrawingRelations;this.copyCaeRelations=copyCaeRelations;this.copyCaeRelationOption=copyCaeRelationOption;this.copyAssociatedFiles=copyAssociatedFiles;this.copySpecification=copySpecification;this.copyManifestation=copyManifestation;this.copyAltrep=copyAltrep;this.copyCaeMotion=copyCaeMotion;this.assignAlternateIds=assignAlternateIds;this.defaultAlternateIdContext=defaultAlternateIdContext;this.defaultAlternateIdType=defaultAlternateIdType;this.outputLogFile=outputLogFile;this.attachLogFile=attachLogFile;this.retainOwnership=retainOwnership;this.defaultOwningUser=defaultOwningUser;this.defaultOwningGroup=defaultOwningGroup;this.defaultChangeNotice=defaultChangeNotice;}
    get Defaultaction(){return this.defaultAction}
    set Defaultaction(val){this.defaultAction = val}
    get Numberingsource(){return this.numberingSource}
    set Numberingsource(val){this.numberingSource = val}
    get Conversionrule(){return this.conversionRule}
    set Conversionrule(val){this.conversionRule = val}
    get Numberingrule(){if(this.numberingRule === undefined) this.numberingRule = new SPLM.TCINDebugSession.CloneNumberingRule(); return this.numberingRule}
    set Numberingrule(val){this.numberingRule = val}
    get Destinationfolder(){return this.destinationFolder}
    set Destinationfolder(val){this.destinationFolder = val}
    get Includecomponentparts(){return this.includeComponentParts}
    set Includecomponentparts(val){this.includeComponentParts = val}
    get Copydrawingrelations(){return this.copyDrawingRelations}
    set Copydrawingrelations(val){this.copyDrawingRelations = val}
    get Copycaerelations(){return this.copyCaeRelations}
    set Copycaerelations(val){this.copyCaeRelations = val}
    get Copycaerelationoption(){return this.copyCaeRelationOption}
    set Copycaerelationoption(val){this.copyCaeRelationOption = val}
    get Copyassociatedfiles(){return this.copyAssociatedFiles}
    set Copyassociatedfiles(val){this.copyAssociatedFiles = val}
    get Copyspecification(){return this.copySpecification}
    set Copyspecification(val){this.copySpecification = val}
    get Copymanifestation(){return this.copyManifestation}
    set Copymanifestation(val){this.copyManifestation = val}
    get Copyaltrep(){return this.copyAltrep}
    set Copyaltrep(val){this.copyAltrep = val}
    get Copycaemotion(){return this.copyCaeMotion}
    set Copycaemotion(val){this.copyCaeMotion = val}
    get Assignalternateids(){return this.assignAlternateIds}
    set Assignalternateids(val){this.assignAlternateIds = val}
    get Defaultalternateidcontext(){return this.defaultAlternateIdContext}
    set Defaultalternateidcontext(val){this.defaultAlternateIdContext = val}
    get Defaultalternateidtype(){return this.defaultAlternateIdType}
    set Defaultalternateidtype(val){this.defaultAlternateIdType = val}
    get Outputlogfile(){return this.outputLogFile}
    set Outputlogfile(val){this.outputLogFile = val}
    get Attachlogfile(){return this.attachLogFile}
    set Attachlogfile(val){this.attachLogFile = val}
    get Retainownership(){return this.retainOwnership}
    set Retainownership(val){this.retainOwnership = val}
    get Defaultowninguser(){return this.defaultOwningUser}
    set Defaultowninguser(val){this.defaultOwningUser = val}
    get Defaultowninggroup(){return this.defaultOwningGroup}
    set Defaultowninggroup(val){this.defaultOwningGroup = val}
    get Defaultchangenotice(){return this.defaultChangeNotice}
    set Defaultchangenotice(val){this.defaultChangeNotice = val}
};

export default SPLM;